import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {DEFAULT_LENGUAJE} from './Constants';
import es from './translations/es/es.json';
import en from './translations/en/en.json';

i18n
.use(initReactI18next)
.init({
    interpolation : {  
        escapeValue :false
    },
    lng :DEFAULT_LENGUAJE,
    resources:{
        es:{
            global : es
        },
        en:{
            global: en
        }
    }
  }); 
  /*----Configuracion de Multilengiaje----*/

  export default i18n;
